import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ObjectNavigator } from './ObjectNavigator';
import { MapViewerContainer } from './MapViewerContainer';
import { Adjustment, SlideMenu, State } from "../menu/SlideMenu";
import { ToolsMenu } from "./ToolsMenu";
import { FaUserCheck, FaUserFriends } from "react-icons/fa";
import { TiImageOutline } from "react-icons/ti";
import { FiTool } from "react-icons/fi";
import { TileInspector } from './TileInspector';
import { MapEditorPlacementSelector } from './MapEditorPlacementSelector';
import { GameStatsContainer } from '../debug/GameStatsContainer';
import { localSettingsStore } from '../../stores/LocalSettingsStore';
import { MapUserOverview } from './MapUserOverview';
import { MapPropertiesMenu } from './MapPropertiesMenu';
import { mainMapEditorStore } from '../../stores/MapEditorStore';
import { EditorCharacterPopup } from '../character/EditorCharacterPopup';
import { CurrentMapTracker } from './CurrentMapTracker';
const FullscreenContainer = styled.div.withConfig({
  displayName: "MapEditor__FullscreenContainer",
  componentId: "sc-fuz4wb-0"
})(["position:fixed;left:0;right:0;top:0;bottom:0;"]);
export const MapEditor = observer(() => {
  const {
    currentMapStore
  } = mainMapEditorStore;
  const {
    hasCurrentMap
  } = currentMapStore;
  const assetsMenuHeight = 260;
  useEffect(() => {
    document.oncontextmenu = function (event) {
      event.preventDefault();
    };

    return () => {
      document.oncontextmenu = null;
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FullscreenContainer, null, hasCurrentMap && /*#__PURE__*/React.createElement(MapViewerContainer, null)), /*#__PURE__*/React.createElement(GameStatsContainer, null), /*#__PURE__*/React.createElement(EditorCharacterPopup, null), /*#__PURE__*/React.createElement(CurrentMapTracker, null), localSettingsStore.isProductionEditor && /*#__PURE__*/React.createElement(SlideMenu, {
    identifier: "map-user-overview",
    orientation: Adjustment.Top,
    start: 800,
    width: 220,
    icon: /*#__PURE__*/React.createElement(FaUserCheck, null),
    state: State.Expanded,
    collapsible: true
  }, /*#__PURE__*/React.createElement(MapUserOverview, null)), currentMapStore.currentMap && /*#__PURE__*/React.createElement(TileInspector, {
    mapEditorStore: mainMapEditorStore
  }), /*#__PURE__*/React.createElement(SlideMenu, {
    identifier: "tools-menu",
    orientation: Adjustment.Top,
    start: 300,
    width: 470,
    icon: /*#__PURE__*/React.createElement(FiTool, null),
    state: State.Expanded,
    collapsible: true
  }, /*#__PURE__*/React.createElement(ToolsMenu, null)), /*#__PURE__*/React.createElement(SlideMenu, {
    identifier: "hierarchy",
    orientation: Adjustment.Left,
    start: 40,
    width: 290,
    icon: /*#__PURE__*/React.createElement(FaUserFriends, null),
    state: State.Expanded,
    collapsible: true
  }, /*#__PURE__*/React.createElement(MapPropertiesMenu, null), hasCurrentMap && /*#__PURE__*/React.createElement(ObjectNavigator, null)), currentMapStore.isUserAllowedToEditCurrentMap && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SlideMenu, {
    identifier: "assets",
    orientation: Adjustment.Bottom,
    start: 0,
    width: "100%",
    height: assetsMenuHeight,
    icon: /*#__PURE__*/React.createElement(TiImageOutline, null),
    state: State.Expanded,
    collapsible: true,
    menuOverflow: "hidden",
    contentHeight: "calc(100% - 4px)"
  }, /*#__PURE__*/React.createElement(MapEditorPlacementSelector, null))));
});